import React, { useEffect, useState } from "react";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";

export type Tab = {
  id: string;
  label: string;
  content: React.ReactNode;
};

type Props = {
  className?: string;
  tabs: Tab[];
};

function Tabs({ tabs, className }: Props) {
  const { color2 } = useAppSelector(selectStyle);
  const [activeTab, setActiveTab] = useState<string>(tabs[0].id);
  useEffect(() => {
    setActiveTab(tabs[0].id);
  }, [tabs]);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    
    <div className={className}>
      <div className="flex">
        {tabs.map((tab) =>
         (
          <button
            key={tab.id}
            style={{
              borderColor: activeTab === tab.id ? color2 : "", 
              color: activeTab === tab.id ? color2 : ""}}            
            className={`px-4 py-2 uppercase hover:text-blue ${
              activeTab === tab.id
                ? "border-b-2"
                : "text-black"
            }`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`${activeTab === tab.id ? "block" : "hidden"} mt-4`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tabs;
